export default __webpack_public_path__ + "static/media/work_ec-user.2caf71c4.jpg";